enum NegotiationTypeEnum {
  Acordo = 'A',
  Faturamento = 'F',
  PagamentoAvulso = 'PA',
  Promessa = 'PR',
  Renegociacao = 'R',
}

export default NegotiationTypeEnum
